import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, withText } from 'preact-i18n';

@withText(() => ({
    followText: <Text id='article.follow'>Follow</Text>,
    unfollowText: <Text id='article.unfollow'>Unfollow</Text>,
}))
@observer
class FollowButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            followed: Boolean(props.followed),
            saving: false,
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.followed !== this.props.followed && !this.state.saving) {
            this.setState({ followed: Boolean(nextProps.followed) });
        }
    }

    toggleFollowed = async (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (this.state.saving) return;

        const {
            stores,
            hostname,
            targetType,
            targetValue,
            onPreferenceChange,
            surface = 'feed',
        } = this.props;
        const { appState } = stores;
        const previousFollowed = this.state.followed;
        const followed = !previousFollowed;
        this.setState({ followed, saving: true });
        onPreferenceChange?.(targetType, targetValue, followed, { optimistic: true });
        try {
            const target = targetType === 'author'
                ? { authorId: Number(targetValue) }
                : { topic: targetValue };
            const response = await util.fetchApi('/api/feedpreferences/', {
                method: 'PATCH',
                publish: false,
            }, {
                hostname,
                ...target,
                followed: followed ? 1 : 0,
            });
            if (response?.status !== 200) {
                throw new Error(response?.message || 'Follow failed');
            }
            this.setState({ followed, saving: false });
            onPreferenceChange?.(targetType, targetValue, followed, {
                confirmed: true,
                preference: response.data,
            });
            appState.addUsageLog({
                type: followed ? 'feed_preference_follow' : 'feed_preference_unfollow',
                props: { targetType, surface },
                timestamp: Math.floor(Date.now() / 1000),
            });
        } catch (error) {
            this.setState({ followed: previousFollowed, saving: false });
            onPreferenceChange?.(targetType, targetValue, previousFollowed, { rollback: true });
            appState.addToast({
                type: 'error',
                message: <Text id='article.follow-failed'>Could not update what you follow.</Text>,
            }, 4000);
        }
    }

    render() {
        const { followText, unfollowText, showLabel = false, targetType } = this.props;
        const { followed, saving } = this.state;
        const label = followed ? unfollowText : followText;
        return (
            <button
                type='button'
                class={`btn btn-sm btn-link p-0 ${showLabel ? 'ms-2' : 'ms-1'} text-muted text-decoration-none`}
                aria-pressed={followed ? 'true' : 'false'}
                aria-label={label}
                title={label}
                disabled={saving}
                onClick={this.toggleFollowed}
            >
                <i class={`fa-solid fa-${targetType === 'author'
                    ? (followed ? 'user-check' : 'user-plus')
                    : (followed ? 'circle-check' : 'circle-plus')}`} />
                {showLabel && <span class='ms-1'>{label}</span>}
            </button>
        );
    }
}

export default FollowButton;
